import React from "react";
import ProyectoAPI from "../../api/proyectos-api";
import { Messages } from "../../helpers/message-helper";
import Fa from "../common/Fa";

/**
 * Componente que representa el formulario de alta y modificación de un
 * recurso.
 */
export default class EventoList extends React.Component {
  state = {
    loading: false,
    lista: []
  };

  iconMap = {
    VAL_ANCHO_CALLE: "road",
    VAL_PORCETAJE_PUBLICO: "map",
    VAL_PROCENTAJE_ERROR: "tree-alt"
  };
  /**
   * Cuando el componente se monta se setea la referencia y se dispara el load inicial.
   */
  componentWillMount() {
    this.listar();
  }

  listar() {
    ProyectoAPI.eventos(this.props.proyecto).then(response => {
      this.setState({
        loading: false,
        lista: response.data
      });
    });
  }

  parse(tpl, data) {
    if (typeof data === "undefined") {
      return tpl;
    }
    var txt = tpl;
    for (var key in data) {
      txt = txt.replace("${" + key + "}", data[key]);
    }
    return txt;
  }

  eventos() {
    return this.state.lista.map((item, index) => {
      var det = item.detalle;
      var icon = this.iconMap[det.tipo];
      var txt = this.parse(item.evento, det);
      return (
        <a key={index} className="panel-block">
          <span className="panel-icon">
            <Fa icon={icon} />
          </span>
          <p>{txt}</p>
        </a>
      );
    });
  }

  render() {
    return <div className="is-fullwidth ">{this.eventos()}</div>;
  }
}
